import React from 'react';

import { footerItem, RequestAccessForm } from '../../../api/types';
import styles from './footer-links.module.css';
import { useFetchRequestAccessForm } from '../../../api/hooks/useFetchRequestAccessForm';

const FooterLinks = () => {
    const { data } = useFetchRequestAccessForm() as { data: RequestAccessForm };

    const footers = data?.footers;

    const firstRow = footers ? footers.slice(0, 2) : [];
    const secondRow: footerItem | undefined =
        footers && footers.length > 2 ? footers[2] : undefined;

    return (
        <div className={styles.footerLinks}>
            <div className={styles.flexRowCentered}>
                {firstRow.map(({ title, url }, index) => (
                    <div className={styles.flexRowCentered} key={`${title}_${url}`}>
                        <a
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.link}
                            key={`${title}_${url}`}
                        >
                            <span>{title}</span>
                        </a>
                        {firstRow.length > 1 && index === 0 && (
                            <span className={styles.linkSeparator}>|</span>
                        )}
                    </div>
                ))}
            </div>
            {secondRow && (
                <div className={styles.flexRowCentered}>
                    <a
                        href={secondRow.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.link}
                    >
                        <span>{secondRow.title}</span>
                    </a>
                </div>
            )}
        </div>
    );
};

export default FooterLinks;
